// 存储应用列表
const eventAddress = (appKey) => {
  localStorage.setItem('appKey', appKey)
}

// 删除应用列表
const removeItem = function() {
  localStorage.removeItem('appKey')
}

export {
  eventAddress,
  removeItem
}
